import React, {useMemo} from "react";
import {AssignUserToCustomerDataGridCellKeys} from "../../../../../../core/constants/table/data-grid-column-keys";
import {
    DataGridColumnAlignments,
    DataGridColumnPinnedTypes,
    DataGridColumnTypes,
    useDataGridSavedState
} from "../../../../../../packages/data-grid";
import Button from "../../../../base/button/button";
import PartnerDataGrid from "../../../../../containers/data-grid";

const dataGridSaveConfig = {
    name: 'AssignUserToCustomerDialogSuggestionsSectionDataGrid',
    version: 1,
}

const AssignUserToCustomerDialogSuggestionsSection = ({suggestions: suggestionsProp, countries, submitting, join}) => {
    const suggestions = useMemo(() => {
        const res = [];
        suggestionsProp.forEach(e => {
            const found = res.findIndex(s => s.code === e.code);
            if (found === -1) {
                res.push({...e, count: 1,})
            }
        });
        return res.map(e => ({
            ...e,
            country: countries?.find(c => c.id === e.province?.countryId)
        }));
    }, [countries, suggestionsProp])

    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            {
                title: "Customer",
                name: AssignUserToCustomerDataGridCellKeys.name,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
                pinned: true,
                width: 180,
            },
            {
                title: "Country",
                name: AssignUserToCustomerDataGridCellKeys.country,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: "Province",
                name: AssignUserToCustomerDataGridCellKeys.province,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: "City",
                name: AssignUserToCustomerDataGridCellKeys.city,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: "Address",
                name: AssignUserToCustomerDataGridCellKeys.address,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
                width: 200,
            },
            {
                title: "Postal/Zip Code",
                name: AssignUserToCustomerDataGridCellKeys.postalCode,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                name: AssignUserToCustomerDataGridCellKeys.select,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.element,
                sortable: false,
                pinned: true,
                pinnedType: DataGridColumnPinnedTypes.right,
                width: 150,
            },
        ], [])

    const [dataGridColumns] = useDataGridSavedState({
        columns: columns,
        name: dataGridSaveConfig.name,
        version: dataGridSaveConfig.version,
    });

    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        return suggestions
                ?.map((customer) => {
                    return {
                        key: customer.code,
                        data: customer,
                        cells: {
                            [AssignUserToCustomerDataGridCellKeys.name]: customer?.companyName,
                            [AssignUserToCustomerDataGridCellKeys.country]: customer?.country?.name,
                            [AssignUserToCustomerDataGridCellKeys.province]: customer?.province?.name,
                            [AssignUserToCustomerDataGridCellKeys.city]: customer?.city,
                            [AssignUserToCustomerDataGridCellKeys.address]: customer?.address,
                            [AssignUserToCustomerDataGridCellKeys.postalCode]: customer?.postalCode,
                            [AssignUserToCustomerDataGridCellKeys.select]:
                                <Button
                                    disabled={submitting}
                                    color={'primary'}
                                    variant={'outlined'}
                                    onClick={() => join(customer)}
                                >
                                    Accept and Join
                                </Button>,
                        }
                    }
                })
            ?? []
    }, [join, submitting, suggestions])

    return (
        <>
            <p className={`text-md black font-weight-semi-bold text-left`}>
                Top Suggestions:
            </p>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                initialLayoutState={{
                    columns: columns,
                }}
                rows={dataGridRows}
                columns={dataGridColumns}
                hideExporting
                hideFooter
                visibleRows={5}
            />
        </>
    );
}

export default AssignUserToCustomerDialogSuggestionsSection;
